




































































































































































import Vue from "vue";
import IconButton from "@/components/IconButton.vue";
import FormSection from "@/components/FormSection.vue";
import CashPreAccHeadPanel from "../components/CashPreAccHeadPanel.vue";
import CashPreAccItemEdit from "../components/CashPreAccItemEdit.vue";
import CashPreAccItemDimensionEdit from "../components/CashPreAccItemDimensionEdit.vue";
import CashPreAccUploadItemsPanel from "../components/CashPreAccUploadItemsPanel.vue";
import store, { CashPreAccEditorStore } from "../services/CashPreAccEditorStore";
import CashPreAccountingApi from "../services/CashPreAccountingApi";
import eventBus from "@/services/eventBus";
import { CashPreAccError } from "../models/CashPreAccounting";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import {
  CashPreAccEditDimension,
  CashPreAccEditDimensionDefaultProps,
  CashPreAccEditItem,
} from "../models/CashPreAccEditing";
import { t } from "@/plugins/i18n";

interface Data {
  store: CashPreAccEditorStore;
  errorMenu: boolean;
  statementErrors: CashPreAccError[];
  uploadItemsVisible: boolean;
  // A számla előkontírozás (PreAccEditorView) mintája: T/K két táblás vagy egy
  // táblás összevont nézet a kontírtételeken
  isMultiTableView: boolean;
}

interface Methods {
  loadCurrent(): Promise<void>;
  loadErrors(): Promise<void>;
  selectFirstItem(): void;
  undoChanges(): void;
  addNewDimension(side: string): void;
  removeDimension(dim: CashPreAccEditDimension): void;
  openInvoice(item: CashPreAccEditItem): void;
  openUploadItems(): void;
  firstEditError(): { message: string; item: CashPreAccEditItem | null };
  validateItems(): string;
  save(): Promise<void>;
  doReAccount(): Promise<void>;
  switchTableView(): void;
}

interface Computed {
  pageTitle: string;
  itemColumns: any[];
  bothColumns: any[];
  dimSectionVisible: boolean;
  validationError: string;
  saveDisabled: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    IconButton,
    FormSection,
    CashPreAccHeadPanel,
    CashPreAccItemEdit,
    CashPreAccItemDimensionEdit,
    CashPreAccUploadItemsPanel,
    ValidationError,
  },

  data() {
    return {
      store,
      errorMenu: false,
      statementErrors: [] as CashPreAccError[],
      uploadItemsVisible: false,
      isMultiTableView: true,
    };
  },

  async mounted() {
    await this.loadCurrent();
    // A kísérő-lookupok (dim-fülek) a háttérben töltődnek
    this.store.loadDimLookups().catch(() => undefined);
  },

  // Kilépés a szerkesztőből: a mentetlen módosítások kérdés nélkül elvesznek (TF-en
  // egységesen így, a K2D closequery-kérdése nélkül). A singleton store deltáit itt
  // nullázzuk, hogy a következő megnyitás tisztán induljon.
  beforeRouteLeave(to: any, from: any, next: any) {
    (this as any).store.resetDeltas();
    next();
  },

  methods: {
    async loadCurrent() {
      const id = Number(this.$route.params.id);
      if (!id) {
        this.$router.push("/cash-pre-accounting");
        return;
      }
      try {
        await this.store.loadEditorData(id);
      } catch {
        // Betölthetetlen kivonaton nem hagyunk szerkesztőnek látszó, üres képernyőt
        // aktív Mentés gombbal — vissza a böngészőre (a banki szerkesztő mintája)
        eventBus.$emit("error", t("CashPreAccounting_APenztarkivonatKontirAdataiNemToltodtek"));
        this.$router.push("/cash-pre-accounting");
        return;
      }
      this.store.isReadOnlyView = !this.store.editable;
      this.selectFirstItem();
      await this.loadErrors();
    },

    // K2D pb_err: az mmacccashdocerr sorai — üres listánál a ⚠ gomb tiltott
    async loadErrors() {
      this.errorMenu = false;
      try {
        this.statementErrors = await CashPreAccountingApi.getErrors(this.store.statementId);
      } catch {
        this.statementErrors = [];
      }
    },

    // K2D pfc_retrieve: fókusz az első Tartozik (ennek híján Követel) sorra
    selectFirstItem() {
      const first =
        this.store.items.find((x) => x.accSign === "+") ??
        this.store.items.find((x) => x.accSign === "-");
      if (first) {
        this.store.selectedItem = first;
      }
    },

    // K2D pb_cancel-analóg: a módosítások elvesznek, vissza a böngészőre
    undoChanges() {
      this.store.resetDeltas();
      this.$router.push("/cash-pre-accounting");
    },

    // Új bontás-sor a kijelölt tételhez az aktív fül típusával
    // (K2D w_popup_accitem_dim_os pb_insert)
    addNewDimension(side: string) {
      if (this.store.isReadOnlyView) return;
      const item = side === "positive" ? this.store.positiveSelectedItem : this.store.negativeSelectedItem;
      if (!item || !this.store.items.includes(item)) {
        eventBus.$emit("warn", t("ElobbJeloljonKiEgyKontirtetelt"));
        return;
      }
      const dimCodeType =
        side === "positive" ? this.store.positiveSelectedDimCodeType : this.store.negativeSelectedDimCodeType;
      const dim: CashPreAccEditDimension = {
        ...CashPreAccEditDimensionDefaultProps,
        id: this.store.nextTempId(),
        head: item.id,
        dimCodeType: dimCodeType,
        total: item.total,
      };
      this.store.dimensionsRows.push(dim);
      this.store.newDimensions.push(dim);
      this.store.selectedDimension = dim;
    },

    // K2D w_popup_accitem_dim_os pb_delete
    removeDimension(dim: CashPreAccEditDimension) {
      if (this.store.isReadOnlyView) return;
      if (dim.id > 0) {
        this.store.deletedDimensions.push(dim.id);
      }
      this.store.dimensionsRows = this.store.dimensionsRows.filter((x) => x !== dim);
      this.store.newDimensions = this.store.newDimensions.filter((x) => x !== dim);
      this.store.modifiedDimensions = this.store.modifiedDimensions.filter((x) => x.id !== dim.id);
    },

    // K2D pb_felad::clicked: már feladott kivonaton (acc_status 4/6) nem nyílik meg
    openUploadItems() {
      if (!this.store.uploadable) {
        eventBus.$emit("warn", t("MarFelVanAdvaAKivonat_2"));
        return;
      }
      this.uploadItemsVisible = true;
    },

    // K2D pb_kont1/pb_kont2: a hivatkozott számla főkönyvi kontírozásának
    // megtekintése — a számla előkontírozás megtekintő nézete (ha a DLMP476
    // nincs a buildben, az útvonal nem létezik, a router marad a helyén)
    openInvoice(item: CashPreAccEditItem) {
      if (!item || item.invNo <= 1 || !item.invCode) return;
      this.$router.push(`/pre-accounting/${item.invCode}/${item.invNo}/view`);
    },

    // K2D-analóg kliens-validáció: fk. szám kötelező minden tételen
    // Az első hibás tétel + hibaüzenet, mellékhatás nélkül — a Mentés melletti
    // hibajelző (validationError computed) és a mentés is ezt használja.
    firstEditError(): { message: string; item: CashPreAccEditItem | null } {
      for (const item of this.store.items) {
        if (!String(item.accCode ?? "").trim()) {
          return { message: t("AFokonyviSzamKitolteseMindenKontirtetelen"), item };
        }
      }
      // K2D f_dimcode_check_os kapuja: a dimenziókód csak külső főkönyvnél (is_ext_book) és
      // csak a kötelezőnek jelölt (csaccdimcodetype.required) típusokon kötelező — a többi
      // bontás-sor üres kóddal is menthető, ahogy a K2D dim-popupja is engedte
      const flags = this.store.flags;
      if (flags.extBook) {
        for (const dim of this.store.dimensionsRows) {
          if (flags.dimTypeRequired[dim.dimCodeType] !== true) continue;
          if (!String(dim.dimCode ?? "").trim()) {
            return { message: t("VanDimenziokodNelkuliBontasSorA"), item: null };
          }
        }
      }
      return { message: "", item: null };
    },

    validateItems(): string {
      const err = this.firstEditError();
      if (err.item) this.store.selectedItem = err.item;
      return err.message;
    },

    // K2D pb_ok: mentés — az ablak nyitva marad, csak újraolvas
    async save() {
      if (this.saveDisabled) return;
      if (!this.store.hasChanges) {
        // K2D: modifiedCount() < 1 → csendes visszatérés; itt jelezzük
        eventBus.$emit("warn", t("NincsMentendoModositas"));
        return;
      }
      const error = this.validateItems();
      if (error) {
        eventBus.$emit("warn", error);
        return;
      }
      try {
        const result = await this.store.save();
        eventBus.$emit(
          "success",
          result.statusChanged
            ? t("AKontirozasMentveKonyvelesAllapot", [result.accStatusName])
            : t("AKontirozasMentve")
        );
        const hasErrors = (result.errors ?? []).length > 0;
        await this.loadCurrent();
        if (hasErrors) {
          eventBus.$emit("warn", t("AKontirozasHibasNezzeMegA"));
          this.errorMenu = this.statementErrors.length > 0;
        }
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      }
    },

    // K2D pb_recontir → f_cash_cont_os port (saját, egy-kivonatos végpont) —
    // megerősítő kérdés nélkül, azonnal indul (user-döntés)
    async doReAccount() {
      try {
        const result = await this.store.reAccount();
        if ((result.failures ?? []).length > 0) {
          eventBus.$emit("warn", result.failures.join(" "));
        } else {
          const updated = (result.updated ?? []).find((u) => u.id === this.store.statementId);
          eventBus.$emit(
            "success",
            updated
              ? t("AKivonatUjrakontirozvaKonyvelesAllapot", [updated.accStatusName])
              : t("AKivonatUjrakontirozva")
          );
        }
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        await this.loadCurrent();
        if (this.statementErrors.length > 0 && [7, 8].includes(Number(this.store.head.accStatus))) {
          this.errorMenu = true;
        }
      }
    },

    switchTableView() {
      this.isMultiTableView = !this.isMultiTableView;
    },
  },

  computed: {
    // A kivonat azonosítása (kivonatszám, pénztár) a fej-panelen ott van, ezért a
    // címben nem ismételjük meg — csak a csak-olvasható állapot jelenik meg.
    pageTitle() {
      return !this.store.editable && this.store.head.id > 0
        ? t("CashPreAccounting_PenztarkivonatKontirozasaCsakOlvashato")
        : t("CashPreAccounting_PenztarkivonatKontirozasa");
    },

    // A K2D d_g_i_cashaccitem_os oszlopai TF-oszlopkészletként; a rejtett/technikai
    // oszlopok (document, docitem, payment, period, bookin_date/time, szam, head)
    // kimaradnak — a bank accTypeName oszlopának pénztári párja a mozgástípus
    itemColumns() {
      return [
        { field: "accCode", title: t("FokonyviSzam"), cell: "accCode", width: "150px" },
        { field: "accCodeName", title: t("FkSzamNeve"), width: "170px" },
        { field: "detailedType", title: t("ReszletezesTipus"), cell: "detailedType", width: "150px" },
        { field: "total", title: t("Osszeg"), cell: "total", width: "130px" },
        { field: "dimCode1", title: t("Dim1"), cell: "dimCode1", width: "120px" },
        { field: "dimCode2", title: t("GeneralLedger_Dim2"), cell: "dimCode2", width: "120px" },
        { field: "dimCode3", title: t("GeneralLedger_Dim3"), cell: "dimCode3", width: "120px" },
        { field: "note", title: t("Megjegyzes"), cell: "note", width: "180px" },
        { field: "partnerName", title: t("Partner"), width: "200px" },
        { field: "invoiceRef", title: t("Szamla"), cell: "invoiceRef", width: "130px" },
        { field: "outerInvNo", title: t("KulsoSzlaSzam"), width: "140px" },
        { field: "cashProcTypeName", title: t("CashPreAccounting_Mozgastipus"), width: "170px" },
        { field: "accDate", title: t("KonyvDatum"), cell: "accDate", width: "110px" },
        { field: "currency", title: t("Penznem"), width: "80px" },
        // Nincs width megadva: Kendo Grid (resizable=true → table-layout:fixed) ezt az
        // oszlopot a maradék szélesség kitöltésére nyújtja — "0px"-re rögzítve ehelyett
        // üres sáv marad a tábla jobb szélén (ld. preAccounting/PreAccEditorView.vue
        // itemColumns ugyanerre javítva, 2026-09-25)
        { sortable: false },
      ];
    },

    // Egy táblás nézet: + Tétel típus oszlop (Tartozik/Követel)
    bothColumns() {
      const cols = this.itemColumns.slice(0, -1);
      cols.push({ field: "accSign", title: t("TetelTipus"), cell: "accSign", width: "95px" });
      cols.push({ sortable: false });
      return cols;
    },

    dimSectionVisible() {
      const flags = this.store.flags;
      if (flags.extBook) {
        for (let t = 5; t <= 13; t++) {
          if (flags.dimTypeLive[t] !== false) return true;
        }
        return false;
      }
      return flags.dim49;
    },

    // A Mentés melletti piros felkiáltójel szövege — csak szerkeszthető
    // állapotban él, betöltés alatt (félkész adatokon) nem villog
    validationError() {
      if (this.store.isReadOnlyView || this.store.isItemsLoading) return "";
      return this.firstEditError().message;
    },

    saveDisabled() {
      return (
        this.store.isReadOnlyView ||
        this.store.isItemsLoading ||
        this.store.isSaving ||
        this.store.isReAccounting ||
        this.validationError !== ""
      );
    },
  },
});
